/**
 * Tenant defaults — centralized canonical tenant IDs.
 *
 * SYS1 introduced a formal tenants collection. Before SYS1, 'watchmen' was
 * used as the implicit demo tenantId. It is kept as a legacy alias so any
 * pre-existing localStorage records continue to resolve after rename.
 */

// Canonical demo tenant — used when no user is authenticated (pre-login / demo mode).
export const DEMO_TENANT_ID = 'elyon-demo';

// First real customer tenant.
export const WATCHMEN_TENANT_ID = 'watchmen-logistics';

// Elyon SCI — operates Kairos itself and is the Customer Zero for every
// ARTEMIS Revenue Intelligence primitive. First production tenant of the
// category-design narrative and the voice-model that ships on elyonsci.ai.
export const ELYON_TENANT_ID = 'elyon-sci';

// Legacy alias used in pre-SYS1 seed data and earlier releases.
export const LEGACY_TENANT_ID = 'watchmen';

// Cross-tenant marker for the ARTEMIS flywheel pattern registry. Never
// attach to a non-flywheel document.
export const FEDERATED_TENANT_ID = '__federated__';

/**
 * Resolve a tenantId, treating the legacy 'watchmen' alias as the demo tenant.
 * Returns the demo tenant when input is falsy.
 */
export function normalizeTenantId(tenantId) {
  if (!tenantId) return DEMO_TENANT_ID;
  if (tenantId === LEGACY_TENANT_ID) return DEMO_TENANT_ID;
  // NCL-FIRESTORE-PERMISSIONS-FIX-1: 'ncl-cruise' was an earlier alias;
  // canonical tenant ID is 'ncl' (live at app.ncl.elyonsci.ai).
  if (tenantId === 'ncl-cruise') return 'ncl';
  return tenantId;
}

// Bump when seed data shape changes — forces re-seed in demo mode.
// 17 (2026-05-28): TMS-AUTOSEED-SEAT-F-PARITY-1 — adds spot_bids + 'accepted' quote status.
export const SEED_VERSION = 17;
